// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divLoginExternal{
    background-color: #373737;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    gap: 16px;
}
 
.divLoginExternalColumn{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    gap: 16px;
}
 
  
.divLoginExternalTitle{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
}
.divLoginExternalIconImg{
    width: 40px;
    height: none;
}

.divLoginExternalText{
    font-size: 32px;
}


.divLoginExternalLogo{
    width: 200px;
    height: auto;
}


.divLoginExternalInput{
    height: 50px;
    background-color: rgba(255, 255, 255, 0.4);
    border: none;
    border-radius: 16px;
    padding-left: 20px;
    color: white;
    font-size: 18px;
    width: 350px;
}
.divLoginExternalInput::placeholder{
    color: white;
}

.divLoginExternalButton{
    height: 50px;
    background-color: #E97247;
    border: none;
    border-radius: 16px;
    color: #ffffff;
    font-size: 20px;
    width: 350px;
    cursor:pointer;
  }
  
  
  .divLoginExternalButtonDisabled{
    height: 50px;
    background-color: #939393;
    border: none;
    border-radius: 16px;
    color: #ffffff;
    font-size: 20px;
    width: 350px;
    cursor:pointer;
  }

.divLoginExternalLoading{
    display: flex;
    align-items: center;
}
  

   
.modal.show .modal-dialog {
    width: 70vw;
    max-width: none;
    padding:10px;
}
  
  
  @media (max-width: 768px) {
    .modal.show .modal-dialog {
      width: 90vw;
      }

    .divLoginExternalTitle{
        gap: 8px;
    }
    .divLoginExternalIconImg{
        width: 40px;
        height: none;
    }

    .divLoginExternalText{
        font-size: 24px;
    }


    .divLoginExternalInput{
        width: 250px;
    }
    .divLoginExternalInput::placeholder{
        color: white;
    }
    
    .divLoginExternalButton{
        width: 250px;
    }
  
  
    .divLoginExternalButtonDisabled{
        width: 250px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/LoginExternalPage/loginExternalPage.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,0CAA0C;IAC1C,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;;;EAGA;IACE,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;;AAEF;IACI,aAAa;IACb,mBAAmB;AACvB;;;;AAIA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;;EAGE;IACE;MACE,WAAW;MACX;;IAEF;QACI,QAAQ;IACZ;IACA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,YAAY;IAChB;EACF","sourcesContent":[".divLoginExternal{\n    background-color: #373737;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    gap: 16px;\n}\n \n.divLoginExternalColumn{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    gap: 16px;\n}\n \n  \n.divLoginExternalTitle{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n}\n.divLoginExternalIconImg{\n    width: 40px;\n    height: none;\n}\n\n.divLoginExternalText{\n    font-size: 32px;\n}\n\n\n.divLoginExternalLogo{\n    width: 200px;\n    height: auto;\n}\n\n\n.divLoginExternalInput{\n    height: 50px;\n    background-color: rgba(255, 255, 255, 0.4);\n    border: none;\n    border-radius: 16px;\n    padding-left: 20px;\n    color: white;\n    font-size: 18px;\n    width: 350px;\n}\n.divLoginExternalInput::placeholder{\n    color: white;\n}\n\n.divLoginExternalButton{\n    height: 50px;\n    background-color: #E97247;\n    border: none;\n    border-radius: 16px;\n    color: #ffffff;\n    font-size: 20px;\n    width: 350px;\n    cursor:pointer;\n  }\n  \n  \n  .divLoginExternalButtonDisabled{\n    height: 50px;\n    background-color: #939393;\n    border: none;\n    border-radius: 16px;\n    color: #ffffff;\n    font-size: 20px;\n    width: 350px;\n    cursor:pointer;\n  }\n\n.divLoginExternalLoading{\n    display: flex;\n    align-items: center;\n}\n  \n\n   \n.modal.show .modal-dialog {\n    width: 70vw;\n    max-width: none;\n    padding:10px;\n}\n  \n  \n  @media (max-width: 768px) {\n    .modal.show .modal-dialog {\n      width: 90vw;\n      }\n\n    .divLoginExternalTitle{\n        gap: 8px;\n    }\n    .divLoginExternalIconImg{\n        width: 40px;\n        height: none;\n    }\n\n    .divLoginExternalText{\n        font-size: 24px;\n    }\n\n\n    .divLoginExternalInput{\n        width: 250px;\n    }\n    .divLoginExternalInput::placeholder{\n        color: white;\n    }\n    \n    .divLoginExternalButton{\n        width: 250px;\n    }\n  \n  \n    .divLoginExternalButtonDisabled{\n        width: 250px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
